export const COUNTRY_CITY = {
  IN: {
    name: "India",
    cities: [
      "Mumbai",
      "Delhi",
      "Bengaluru",
      "Hyderabad",
      "Kolkata",
      "Chennai",
      "Pune",
    ],
  },
  KSA: { name: "Saudi Arabia", cities: ["Riyadh", "Jeddah", "Dammam"] },
  NP: { name: "Nepal", cities: ["Kathmandu", "Pokhara"] },
};

// list of countries for the <select>
export const countries = Object.entries(COUNTRY_CITY).map(
  ([code, { name }]) => ({ code, name }),
);

// city -> country lookup (used to auto-pick country when city changes)
export const cityToCountry = Object.fromEntries(
  Object.entries(COUNTRY_CITY).flatMap(([code, { cities }]) =>
    cities.map((c) => [c, code]),
  ),
);

// --- PHONE COUNTRY META (append only) ---
export const COUNTRY_PHONE = {
  IN: { name: "India", dial: "+91", flag: "🇮🇳" },
  NP: { name: "Nepal", dial: "+977", flag: "🇳🇵" },
  KSA: { name: "Saudi Arabia", dial: "+966", flag: "🇸🇦" },
};

export const phoneCountries = Object.entries(COUNTRY_PHONE).map(
  ([code, v]) => ({ code, name: v.name, flag: v.flag, dial: v.dial }),
);

export const getDialByCountry = (code) => (COUNTRY_PHONE[code]?.dial ?? "");

// helpful to preselect country from an existing dial code
export const dialToCountry = Object.fromEntries(
  Object.entries(COUNTRY_PHONE).map(([code, v]) => [v.dial, code]),
);
